export default __webpack_public_path__ + "static/media/test-avatar2.dea3b861.jpg";